import styled from 'styled-components'

import Heading from '../Typography/Heading'

const CardHeading = styled(Heading)`
  position: relative;
  padding-right: 30px;

  svg {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`

export default CardHeading
